let preparedConfig = {
    debugMode: process.env.NODE_ENV === 'development',
    appRoot: '/',
    appBase: '/',
    UI_URL: process.env.VUE_APP_UI_URL,
    ASSETS_URL: process.env.VUE_APP_ASSETS_URL,
    API_URL: process.env.VUE_APP_BASE_API_URL,
    AMIS_API_URL: process.env.VUE_APP_AMIS_BASE_API_URL,
    // Jira site root used to build ticket links in Release Notes, e.g. 'https://acme.atlassian.net'.
    // Optional: when unset, ticket keys render as plain text instead of links.
    JIRA_BASE_URL: process.env.VUE_APP_JIRA_BASE_URL,
    askAva: process.env.VUE_APP_ASK_AVA,
    // AVA Assistant client (Astryx-look chat, src/features/Assistant). Compared against the 'enabled'
    // string like the flags below. It always talks to the aiva.api agent loop (api/assistant/*, SSE):
    // there is no mock agent or synthetic history at runtime. When enabled, the top bar's "Ask AVA"
    // button (still gated by askAva) opens it and the legacy Ask AVA modal is not mounted.
    // On in .env.development, .env.staging and .env.demo; off in .env.prod until aiva.api with the
    // agent loop is on that server (the UI goes to prod only after the API).
    assistantClient: process.env.VUE_APP_ASSISTANT_CLIENT,
    // "What can AVA do?" button in the assistant header (src/features/Assistant/domain/capabilities.js). Compared
    // against the 'enabled' string. It asks the real agent what this user can do with AVA, by area, from the
    // server's capability catalog. On in .env.development, .env.staging and .env.demo.
    assistantCapabilities: process.env.VUE_APP_ASSISTANT_CAPABILITIES,
    // Composite Source builder (AVA-487). Compared against the 'enabled' string, not
    // truthiness — .env values are always strings, so 'disabled' is truthy too.
    compositeSourceBuilder: process.env.VUE_APP_COMPOSITE_SOURCE_BUILDER,
    // AI analysis dev mock (AVA-531). Compared against the 'enabled' string, like the flags above.
    // When enabled, main.js lazy-loads src/features/Dashboard/mocks and answers the AI endpoints locally.
    // Note: the same AnomalyInsights endpoints feed the existing AI Inspect / Coating Analyser views, so those
    // show fixture data too while the flag is on. Dev-only; never set in .env.staging / .env.prod.
    aiInspectMock: process.env.VUE_APP_AI_INSPECT_MOCK,
    // Chart engine: ECharts is the only engine (graduated 2026-07-20). The automatic Apex fallback
    // for unsupported chart types / lazy-chunk load failure stays in dashboard-widget's chartEngine()
    // computed — this constant only fixes the happy-path default.
    dashboardChartEngineDefault: 'echarts',
};

export default preparedConfig
